import styled from '@emotion/styled'
import React, { memo, useEffect, useLayoutEffect, useState } from 'react'
import Countdown from 'react-countdown'
import { Helmet } from 'react-helmet'

import text from './text.json'

type Contents = typeof text['en']
const validLanguageCodes = Object.keys(text)

export default memo(function PageTemplate() {
  const [contents, setContents] = useState<Contents>(text.en)

  useLayoutEffect(() => {
    const language =
      (window.navigator as any).userLanguage || window.navigator.language
    const languageCode = language.substring(0, 2).toLowerCase()

    if (validLanguageCodes.includes(languageCode)) {
      setContents(text[languageCode as 'en'])
    }
  }, [])

  return (
    <>
      <Helmet>
        <title>{contents.pageTitle} | QNT Hospitality</title>
      </Helmet>
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link
          rel="preconnect"
          href="https://fonts.gstatic.com"
          crossOrigin="anonymous"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@400;600;700&display=swap"
          rel="stylesheet"
        ></link>
      </Helmet>
      <Container>
        <Logo src="logo-zucchetti.svg" />
        <SiteName>QNT Hospitality</SiteName>
        <Wrapper>
          <Title
            dangerouslySetInnerHTML={{
              __html: contents.title,
            }}
          />
          <Text
            dangerouslySetInnerHTML={{
              __html: contents.text,
            }}
          />
        </Wrapper>
        <Illustration src="illustration.png" />
        {/* <Timer
          date={Number(process.env.GATSBY_COUNTDOWN) * 1000}
          daysInHours={true}
        /> */}
      </Container>
    </>
  )
})

const Container = styled.section`
  width: 90%;
  max-width: 1036px;
  font-family: ${({ theme }) => theme.fontFamily.heading};
  position: absolute;
  text-align: center;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  @media (max-height: 700px) {
    margin: auto;
    padding: 1.5rem 0 3.75rem;
    position: relative;
    top: auto;
    left: auto;
    transform: none;
  }
`

const Logo = styled.img`
  margin: 3rem auto 0;
  max-height: 35px;
  width: auto;
`

const SiteName = styled.div`
  color: ${({ theme }) => theme.colors.variants.neutralDark2};
  font-size: 0.8125rem;
  font-weight: 600;
  letter-spacing: 0.0437rem;
  margin-top: 0.375rem;
`

const Wrapper = styled.div`
  margin: 3rem auto 0;
  max-width: 600px;
`

const Title = styled.h2`
  color: ${({ theme }) => theme.colors.variants.neutralDark1};
  font-size: 3.125rem;
  font-weight: 700;

  @media (max-width: 767px) {
    font-size: 1.875rem;
  }
`

const Text = styled.div`
  color: ${({ theme }) => theme.colors.variants.neutralDark2};
  font-size: 1rem;
  line-height: 1.5rem;
  margin-top: 1.5rem;

  @media (max-width: 767px) {
    margin-top: 1.125rem;
  }
`

const Illustration = styled.img`
  display: block;
  width: 100%;
  margin-top: 3.75rem;
`

const Timer = styled(Countdown)`
  display: block;
  border-top: 1px solid ${({ theme }) => theme.colors.variants.neutralLight3};
  color: ${({ theme }) => theme.colors.variants.neutralDark2};
  font-size: 1.875rem;
  font-weight: 700;
  margin-top: 3.75rem;
  padding-top: 3rem;
`
